import * as angular from "angular";
import { DialogUtils } from "../../helper/dialog.helper";

let DeleteCampaignDialog = {
    selector: "vcDeleteCampaignDialog",
    templateUrl:
        "/angular/components/profile/delete-campaign-dialog.component.html",
    bindings: {},
    controller: class DeleteCampaignDialogController {
        public deletion = {};

        public __env: any;
        private dialog: DialogUtils;

        constructor(__env: any, DialogUtils: DialogUtils) {
            this.__env = __env;
            this.dialog = DialogUtils;
        }

        confirm(): void {
            this.dialog.hide(this.deletion);
        }

        cancel(): void {
            this.dialog.cancel();
        }
    },
};

angular
    .module("profile")
    .component(DeleteCampaignDialog.selector, DeleteCampaignDialog);
